import { globalCss } from 'theme';

export default globalCss({
  '*, *::before, *::after': {
    boxSizing: 'border-box',
  },
  body: {
    margin: '0',
    fontFamily: '$base',
    lineHeight: '$base',
    letterSpacing: '$wide',
    color: '$bodyGrey',
  },
});
